import { render } from "./ViewPublicationPostList.vue.js?vue&type=template&id=94a1d3e8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPostList.vue?vue&type=template&id=94a1d3e8"
import script from "./ViewPublicationPostList.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPostList.vue?vue&type=script&lang=js"
export * from "./ViewPublicationPostList.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPostList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ViewPublicationPostList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94a1d3e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94a1d3e8', __exports__)) {
    api.reload('94a1d3e8', __exports__)
  }
  
  module.hot.accept("./ViewPublicationPostList.vue.js?vue&type=template&id=94a1d3e8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPostList.vue?vue&type=template&id=94a1d3e8", () => {
    api.rerender('94a1d3e8', render)
  })

}


export default __exports__